import { useState, useEffect } from "react";

const useClock = (targetTime, countdownSeconds) => {
  const [time, setTime] = useState(
    targetTime ? new Date(targetTime) : new Date()
  );

  useEffect(() => {
    setTime(targetTime ? new Date(targetTime) : new Date());

    if (!targetTime) {
      const interval = setInterval(() => {
        setTime(new Date());
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [targetTime]);

  const [clockData, setClockData] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
    ampm: "AM",
    day: "01",
    month: "Jan",
    year: "2025",
    hourAngle: 0,
    minuteAngle: 0,
    secondAngle: 0,
    countdownAngle: 0,
  });

  useEffect(() => {
    const updateClock = () => {
      const date = time;
      let hh = date.getHours();
      let mm = date.getMinutes();
      let ss = date.getSeconds();
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let ampm = hh >= 12 ? "PM" : "AM";

      // Calculate countdown angle if countdownSeconds is provided
      const countdownAngle =
        countdownSeconds !== undefined
          ? (countdownSeconds / 30) * 360 // 360 degrees for full circle
          : 0;

      hh = hh % 12 || 12; // Convert 24-hour format to 12-hour format
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      setClockData({
        hours: hh.toString().padStart(2, "0"),
        minutes: mm.toString().padStart(2, "0"),
        seconds: ss.toString().padStart(2, "0"),
        ampm: ampm,
        day: day.toString().padStart(2, "0"),
        month: months[month],
        year: year.toString(),
        hourAngle: hh * 30 + mm / 2, // 30 degrees per hour + offset by minutes
        minuteAngle: mm * 6, // 6 degrees per minute
        secondAngle: ss * 6, // 6 degrees per second
        countdownAngle: countdownAngle,
      });
    };

    updateClock(); // Initialize immediately
    const interval = setInterval(updateClock, 1000);

    return () => clearInterval(interval);
  }, [time]);

  return clockData;
};

export default useClock;
